// function initMultiAtcSection(sectionId) {
//   const container = document.getElementById(`multi-atc-section-${sectionId}`);
//   if (!container) return;

//   const qtyInputs = container.querySelectorAll(".hkt--multi-atc-qty-input");
//   const totalValueElement = container.querySelector("#hkt--multi-atc-total-value");
//   const priceMap = window[`HKTPriceMap_${sectionId}`] || {};
//   const currency = window[`HKTCurrency_${sectionId}`] || 'USD';
//   const PRODUCT_VISIBLE_COUNT = window[`HKTProductVisibleCount_${sectionId}`] || 3;
//   const hktSuccessPopupItems = new Map(); // key: variantId, value: { quantity, title, imageSrc }
//   let hktPopupTimeout;

//   function formatMoney(cents) {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: currency
//     }).format(cents / 100);
//   }

//   function updateTotal() {
//     let total = 0;
//     qtyInputs.forEach(input => {
//       const qty = parseInt(input.value) || 0;
//       const variantId = input.dataset.variantId;
//       const unitPrice = priceMap[variantId];
//       const lineTotal = qty * unitPrice;
//       total += lineTotal;

//       const dynamicPrice = container.querySelector(`#product-dynamic-price-${variantId}`);
//       if (dynamicPrice) {
//         dynamicPrice.textContent = formatMoney(lineTotal > 0 ? lineTotal : unitPrice);
//       }
//     });

//     if (totalValueElement) {
//       totalValueElement.textContent = formatMoney(total);
//     }
//   }

//   container.querySelectorAll(".hkt--multi-atc-qty-btn").forEach(btn => {
//     if (btn._boundClick) btn.removeEventListener("click", btn._boundClick);

//     btn._boundClick = () => {
//   const input = btn.parentElement.querySelector(".hkt--multi-atc-qty-input");
//   if (!input) return;
//   let currentValue = parseInt(input.value) || 0;
//   const variantId = input.dataset.variantId;

//   if (btn.dataset.action === "increase") {
//     const newQty = currentValue + 1;
//     input.value = newQty;

//     // Immediately add to cart
//     fetch("/cart/add.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         items: [{
//           id: variantId,
//           quantity: 1
//         }]
//       })
//     })
//     .then(res => res.json())
//     .then(() => fetch("/cart.js"))
// .then(res => res.json())
// .then(cart => {
//   const cartCountBubble = document.querySelector('.cart-count-bubble');
//   if (cartCountBubble) {
//     cartCountBubble.textContent = cart.item_count || 0;
//   }
//   showSuccessPopupFromCart(cart);
// })
//     .catch(err => console.error("Auto add to cart failed:", err));
//   }

//   if (btn.dataset.action === "decrease" && currentValue > 0) {
//     input.value = currentValue - 1;
//   }

//   updateTotal();
// };


//     btn.addEventListener("click", btn._boundClick);
//   });

//   qtyInputs.forEach(input => {
//     input.addEventListener("input", updateTotal);
//   });

//   updateTotal();

//   // Add to Cart logic with popup
//   const addToCartBtn = container.querySelector(".hkt--multi-atc-submit-btn");
//   if (addToCartBtn) {
//     addToCartBtn.addEventListener("click", () => {
//       const items = [];

//       qtyInputs.forEach(input => {
//         const qty = parseInt(input.value) || 0;
//         const variantId = input.dataset.variantId;
//         if (qty > 0 && variantId) {
//           // Collect product title & image from DOM
//           const productCard = input.closest('[data-product-index]');
//           const title = productCard ? productCard.querySelector('.hkt--multi-atc__form-product-title--price h2')?.textContent.trim() || '' : '';
//           const imageSrc = productCard ? productCard.querySelector('img')?.src || '' : '';

//           items.push({
//             id: variantId,
//             quantity: qty,
//             title,
//             imageSrc
//           });
//         }
//       });

//       if (items.length === 0) return;

//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({ items })
//       })
//         .then(res => res.json())
//         .then(() => {
      
//         return fetch("/cart.js");
//       })
//       .then(res => res.json())
//       .then(cart => {
//   const realCartCount = cart.item_count || 0;
//   const cartCountBubble = document.querySelector('.cart-count-bubble');
//   if (cartCountBubble) {
//     cartCountBubble.textContent = realCartCount;
//   }

//   showSuccessPopupFromCart(cart);
//   qtyInputs.forEach(input => input.value = 0);
//   updateTotal();
// })
//       .catch(err => {
//         console.error("Add to cart or cart fetch failed:", err);
//       });
       
//     });
//   }

//   function toggleProductVisibility(showAll) {
//     const productCards = container.querySelectorAll('[data-product-index]');
//     productCards.forEach((card, index) => {
//       card.style.display = (showAll || index < PRODUCT_VISIBLE_COUNT) ? '' : 'none';
//     });

//     const loadMoreBtn = container.querySelector("#hkt--load-more-btn");
//     const loadLessBtn = container.querySelector("#hkt--load-less-btn");

//     if (loadMoreBtn && loadLessBtn) {
//       loadMoreBtn.style.display = showAll ? 'none' : '';
//       loadLessBtn.style.display = showAll ? '' : 'none';
//     }
//   }

//   const productCards = container.querySelectorAll('[data-product-index]');
//   const loadMoreBtn = container.querySelector("#hkt--load-more-btn");
//   const loadLessBtn = container.querySelector("#hkt--load-less-btn");

//   if (productCards.length <= PRODUCT_VISIBLE_COUNT) {
//     if (loadMoreBtn) loadMoreBtn.style.display = 'none';
//     if (loadLessBtn) loadLessBtn.style.display = 'none';
//     productCards.forEach(card => card.style.display = '');
//   } else {
//     toggleProductVisibility(false);
//     if (loadMoreBtn) loadMoreBtn.addEventListener("click", () => toggleProductVisibility(true));
//     if (loadLessBtn) loadLessBtn.addEventListener("click", () => toggleProductVisibility(false));
//   }
// }

// // Init all multi-atc sections
// document.querySelectorAll("[id^='multi-atc-section-']").forEach(el => {
//   const id = el.id.replace('multi-atc-section-', '');
//   initMultiAtcSection(id);
// });

// // Show success popup with product info and close button
// function showSuccessPopupFromCart(cart) {
//   const popup = document.getElementById("hkt--success-popup");
//   if (!popup || !cart || !cart.items) return;

//   let contentHtml = `
//     <button id="hkt--success-popup-close" 
//             style="
//               position: absolute; 
//               top: 5px; 
//               right: 8px; 
//               background: transparent; 
//               border: none; 
//               color: black; 
//               font-size: 18px; 
//               cursor: pointer;
//             "
//             aria-label="Close popup"
//     >&times;</button>
//     <strong>Cart Updated:</strong><br>
//     <ul style="list-style:none; padding-left:0; margin:0; margin-top: 8px;">
//   `;

//   cart.items.forEach(item => {
//     contentHtml += `
//       <li style="display:flex; align-items:center; margin-bottom:8px;">
//         <img src="${item.image}" alt="${item.title}" 
//              style="width:40px; height:40px; object-fit:cover; margin-right:10px; border-radius:4px;"/>
//         <span>${item.title} × <span style="color:green;font-weight:bold;"> ${item.quantity}</span></span>
//       </li>
//     `;
//   });

//   contentHtml += `
//     </ul>
//     <div style="text-align: right; margin-top: 15px;">
//       <a href="/checkout" class="hk-popup-checkout">
//          Proceed to Checkout
//       </a>
//     </div>
//   `;

//   popup.innerHTML = contentHtml;
//   popup.style.display = "block";
//   popup.style.opacity = "1";
//   popup.style.position = "fixed";
//   popup.style.top = "100px";
//   popup.style.right = "20px";
//   popup.style.background = "#fff";
//   popup.style.color = "#000";
//   popup.style.padding = "15px 20px";
//   popup.style.borderRadius = "5px";
//   popup.style.zIndex = "9999";
//   popup.style.maxWidth = "320px";
//   popup.style.boxShadow = "0 2px 8px rgba(0,0,0,0.2)";

//   const closeBtn = document.getElementById("hkt--success-popup-close");
//   if (closeBtn) {
//     closeBtn.addEventListener("click", () => {
//       popup.style.display = "none";
//       popup.innerHTML = "";
//       popup.style.opacity = "0";
//       popup.style.transition = "";
//     });
//   }

//   setTimeout(() => {
//     popup.style.transition = "opacity 0.5s ease";
//     popup.style.opacity = "0";
//     setTimeout(() => {
//       popup.style.display = "none";
//       popup.style.transition = "";
//       popup.innerHTML = "";
//     }, 500);
//   }, 10000);
// }

// SHK Code

// function initMultiAtcSection(sectionId) {
//   const container = document.getElementById(`multi-atc-section-${sectionId}`);
//   if (!container) return;

//   const qtyInputs = container.querySelectorAll(".hkt--multi-atc-qty-input");
//   const totalValueElement = container.querySelector("#hkt--multi-atc-total-value");
//   const priceMap = window[`HKTPriceMap_${sectionId}`] || {};
//   const currency = window[`HKTCurrency_${sectionId}`] || 'USD';
//   const PRODUCT_VISIBLE_COUNT = window[`HKTProductVisibleCount_${sectionId}`] || 3;

//   function formatMoney(cents) {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: currency
//     }).format(cents / 100);
//   }

//   function updateTotal() {
//     let total = 0;
//     qtyInputs.forEach(input => {
//       const qty = parseInt(input.value) || 0;
//       const variantId = input.dataset.variantId;
//       const unitPrice = priceMap[variantId];
//       const lineTotal = qty * unitPrice;
//       total += lineTotal;

//       const dynamicPrice = container.querySelector(`#product-dynamic-price-${variantId}`);
//       if (dynamicPrice) {
//         dynamicPrice.textContent = formatMoney(lineTotal > 0 ? lineTotal : unitPrice);
//       }
//     });

//     if (totalValueElement) {
//       totalValueElement.textContent = formatMoney(total);
//     }
//     const wrapper = container.querySelector('.hkt-add-to-cart-wrapper');
//     wrapper.style.display = [...qtyInputs].some(input => parseInt(input.value) >= 10) ? 'block' : 'none';
//   }

//   container.querySelectorAll(".hkt--multi-atc-qty-btn").forEach(btn => {
//     if (btn._boundClick) btn.removeEventListener("click", btn._boundClick);

//     btn._boundClick = () => {
//       const input = btn.parentElement.querySelector(".hkt--multi-atc-qty-input");
//       if (!input) return;
//       let currentValue = parseInt(input.value) || 0;
//       const variantId = input.dataset.variantId;

//       if (btn.dataset.action === "increase") {
//         const newQty = currentValue + 1;
//         input.value = newQty;

//         const productCard = input.closest('[data-product-index]');
//         const title = productCard?.querySelector('.hkt--multi-atc__form-product-title--price h2')?.textContent.trim() || '';
//         const imageSrc = productCard?.querySelector('img')?.src || '';

//         const addedItems = [{ id: variantId, quantity: 1, title, imageSrc }];

//         fetch("/cart/add.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ items: addedItems })
//         })
//         .then(() => {
//           const cartCountBubble = document.querySelector('.cart-count-bubble');
//           if (cartCountBubble) {
//             cartCountBubble.textContent = parseInt(cartCountBubble.textContent || 0) + 1;
//           }
//           showSuccessPopupFromCart(addedItems);
//         })
//         .catch(err => console.error("Auto add to cart failed:", err));
//       }

//       if (btn.dataset.action === "decrease" && currentValue > 0) {
//         input.value = currentValue - 1;
//       }

//       updateTotal();
//     };

//     btn.addEventListener("click", btn._boundClick);
//   });

//   qtyInputs.forEach(input => {
//     input.addEventListener("input", updateTotal);
//   });

//   updateTotal();

//   const addToCartBtn = container.querySelector(".hkt--multi-atc-submit-btn");
//   if (addToCartBtn) {
//     addToCartBtn.addEventListener("click", () => {
//       const items = [];

//       qtyInputs.forEach(input => {
//         const qty = parseInt(input.value) || 0;
//         const variantId = input.dataset.variantId;
//         if (qty > 0 && variantId) {
//           const productCard = input.closest('[data-product-index]');
//           const title = productCard?.querySelector('.hkt--multi-atc__form-product-title--price h2')?.textContent.trim() || '';
//           const imageSrc = productCard?.querySelector('img')?.src || '';

//           items.push({ id: variantId, quantity: qty, title, imageSrc });
//         }
//       });

//       if (items.length === 0) return;

//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ items })
//       })
//       .then(() => {
//         const cartCountBubble = document.querySelector('.cart-count-bubble');
//         if (cartCountBubble) {
//           cartCountBubble.textContent = parseInt(cartCountBubble.textContent || 0) + items.reduce((a, b) => a + b.quantity, 0);
//         }
//         showSuccessPopupFromCart(items);
//         qtyInputs.forEach(input => input.value = 0);
//         updateTotal();
//       })
//       .catch(err => console.error("Add to cart or cart fetch failed:", err));
//     });
//   }

//   function toggleProductVisibility(showAll) {
//     const productCards = container.querySelectorAll('[data-product-index]');
//     productCards.forEach((card, index) => {
//       card.style.display = (showAll || index < PRODUCT_VISIBLE_COUNT) ? '' : 'none';
//     });

//     const loadMoreBtn = container.querySelector("#hkt--load-more-btn");
//     const loadLessBtn = container.querySelector("#hkt--load-less-btn");

//     if (loadMoreBtn && loadLessBtn) {
//       loadMoreBtn.style.display = showAll ? 'none' : '';
//       loadLessBtn.style.display = showAll ? '' : 'none';
//     }
//   }

//   const productCards = container.querySelectorAll('[data-product-index]');
//   const loadMoreBtn = container.querySelector("#hkt--load-more-btn");
//   const loadLessBtn = container.querySelector("#hkt--load-less-btn");

//   if (productCards.length <= PRODUCT_VISIBLE_COUNT) {
//     if (loadMoreBtn) loadMoreBtn.style.display = 'none';
//     if (loadLessBtn) loadLessBtn.style.display = 'none';
//     productCards.forEach(card => card.style.display = '');
//   } else {
//     toggleProductVisibility(false);
//     if (loadMoreBtn) loadMoreBtn.addEventListener("click", () => toggleProductVisibility(true));
//     if (loadLessBtn) loadLessBtn.addEventListener("click", () => toggleProductVisibility(false));
//   }
// }

// document.querySelectorAll("[id^='multi-atc-section-']").forEach(el => {
//   const id = el.id.replace('multi-atc-section-', '');
//   initMultiAtcSection(id);
// });

// function showSuccessPopupFromCart(addedItems) {
//   fetch("/cart.js")
//     .then(res => res.json())
//     .then(cart => {
//       const popup = document.getElementById("hkt--success-popup");
//       if (!popup || !addedItems) return;

//       let contentHtml = `
//         <button id="hkt--success-popup-close" style="position:absolute;top:5px;right:8px;background:transparent;border:none;color:black;font-size:18px;cursor:pointer;">&times;</button>
//         <strong>Added to Cart:</strong><br>
//         <ul style="list-style:none;padding-left:0;margin:0;margin-top:8px;">
//       `;

//       addedItems.forEach(item => {
//         const cartItem = cart.items.find(ci => ci.variant_id == item.id || ci.id == item.id);
//         const finalQty = cartItem?.quantity || item.quantity;

//         contentHtml += `
//           <li style="display:flex;align-items:center;margin-bottom:8px;">
//             <img src="${item.imageSrc}" alt="${item.title}" style="width:40px;height:40px;object-fit:cover;margin-right:10px;border-radius:4px;"/>
//             <span>${item.title} × <span style="color:green;font-weight:bold;">${finalQty}</span></span>
//           </li>
//         `;
//       });

//       contentHtml += `
//         </ul>
//         <div style="text-align:right;margin-top:15px;">
//           <a href="/checkout" class="hk-popup-checkout">Proceed to Checkout</a>
//         </div>
//       `;

//       popup.innerHTML = contentHtml;
//       popup.style.display = "block";
//       popup.style.opacity = "1";
//       popup.style.position = "fixed";
//       popup.style.top = "100px";
//       popup.style.right = "20px";
//       popup.style.background = "#fff";
//       popup.style.color = "#000";
//       popup.style.padding = "15px 20px";
//       popup.style.borderRadius = "5px";
//       popup.style.zIndex = "9999";
//       popup.style.maxWidth = "320px";
//       popup.style.boxShadow = "0 2px 8px rgba(0,0,0,0.2)";

//       const closeBtn = document.getElementById("hkt--success-popup-close");
//       if (closeBtn) {
//         closeBtn.addEventListener("click", () => {
//           popup.style.display = "none";
//           popup.innerHTML = "";
//           popup.style.opacity = "0";
//           popup.style.transition = "";
//         });
//       }

//       setTimeout(() => {
//         popup.style.transition = "opacity 0.5s ease";
//         popup.style.opacity = "0";
//         setTimeout(() => {
//           popup.style.display = "none";
//           popup.style.transition = "";
//           popup.innerHTML = "";
//         }, 500);
//       }, 1000);
//     })
//     .catch(err => console.error("Cart fetch error:", err));
// }

// SHK Code 6/27/2025
const cartQueue = []
let processing = false

function processQueue() {
  if (processing || cartQueue.length === 0) return
  processing = true

  const { variantId, title, imageSrc, quantity } = cartQueue.shift()
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: [{ id: variantId, quantity, title, imageSrc }] })
  })
    .then(() => {
      const cartCountBubble = document.querySelector('.cart-count-bubble')
      if (cartCountBubble) cartCountBubble.textContent = parseInt(cartCountBubble.textContent || 0) + 1
      showSuccessPopupFromCart([{ id: variantId, quantity, title, imageSrc }])
    })
    .catch(err => console.error("Cart add fail:", err))
    .finally(() => {
      processing = false
      processQueue()
    })
}

function initMultiAtcSection(sectionId) {
  const container = document.querySelector(`[data-section-id="${sectionId}"]`)
  if (!container) return

  const qtyInputs = container.querySelectorAll(".hkt--multi-atc-qty-input")
  const totalValueElement = container.querySelector("#hkt--multi-atc-total-value")
  const priceMap = window[`HKTPriceMap_${sectionId}`] || {}
  const currency = window[`HKTCurrency_${sectionId}`] || 'USD'
  const PRODUCT_VISIBLE_COUNT = window[`HKTProductVisibleCount_${sectionId}`] || 3

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(cents / 100)
  }

  function updateTotal() {
    let total = 0
    qtyInputs.forEach(input => {
      const qty = parseInt(input.value) || 0
      const wrapper = input.closest('.hkt-qty-wrapper')?.querySelector('.hkt-add-to-cart-wrapper')
      if (wrapper) wrapper.style.display = qty >= 10 ? 'block' : 'none'
    })
    if (totalValueElement) totalValueElement.textContent = formatMoney(total)
  }

  container.querySelectorAll(".hkt--multi-atc-qty-btn").forEach(btn => {
    if (btn._boundClick) btn.removeEventListener("click", btn._boundClick)

    btn._boundClick = () => {
      const input = btn.parentElement.querySelector(".hkt--multi-atc-qty-input")
      if (!input) return
      let currentValue = parseInt(input.value) || 0
      const variantId = input.dataset.variantId

// if (btn.dataset.action === "increase") {
//   const maxStock = input.dataset.maxStock !== undefined ? parseInt(input.dataset.maxStock) : 9999

//   if (maxStock === 0) {
//     alert("This item is currently out of stock!")
//     return
//   }

//   if (currentValue + 1 > maxStock) {
//     alert("Oops! Only " + maxStock + " items are available in stock.")
//     return
//   }

//   input.value = currentValue + 1
//   const productCard = input.closest('[data-product-index]')
//   const title = productCard?.querySelector('.hkt--multi-atc__form-product-title--price h2')?.textContent.trim() || ''
//   const imageSrc = productCard?.querySelector('img')?.src || ''
//   const tempItem = { id: variantId, quantity: currentValue + 1, title, imageSrc }
//   showSuccessPopupFromCart([tempItem], true)

//   let existingItem = cartQueue.find(i => i.variantId === variantId)
//   if (existingItem) {
//     existingItem.quantity = (existingItem.quantity || 1) + 1
//   } else {
//     cartQueue.push({ variantId, title, imageSrc, quantity: 1 })
//   }
//   processQueue()
// }
if (btn.dataset.action === "increase") {
  const maxStock = input.dataset.maxStock !== undefined ? parseInt(input.dataset.maxStock) : 9999
  const continueSelling = input.dataset.continueSelling === "true"

  if (!continueSelling) {
    if (maxStock === 0) {
      alert("This item is currently out of stock!")
      return
    }
    if (currentValue + 1 > maxStock) {
      alert("Oops! Only " + maxStock + " items are available in stock.")
      return
    }
  }

  input.value = currentValue + 1
  const productCard = input.closest('[data-product-index]')
  const title = productCard?.querySelector('.hkt--multi-atc__form-product-title--price h2')?.textContent.trim() || ''
  const imageSrc = productCard?.querySelector('img')?.src || ''
  const tempItem = { id: variantId, quantity: currentValue + 1, title, imageSrc }
  showSuccessPopupFromCart([tempItem], true)

  let existingItem = cartQueue.find(i => i.variantId === variantId)
  if (existingItem) {
    existingItem.quantity = (existingItem.quantity || 1) + 1
  } else {
    cartQueue.push({ variantId, title, imageSrc, quantity: 1 })
  }
  processQueue()
}


      if (btn.dataset.action === "decrease" && currentValue > 0) input.value = currentValue - 1

      updateTotal()
    }

    btn.addEventListener("click", btn._boundClick)
  })

  qtyInputs.forEach(input => {
    input.addEventListener("input", updateTotal)
  })

  updateTotal()

  const allAddToCartBtns = container.querySelectorAll(".hkt--multi-atc-submit-btn")
  allAddToCartBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      const wrapper = btn.closest(".hkt-qty-wrapper")
      const input = wrapper.querySelector(".hkt--multi-atc-qty-input")
      const qty = parseInt(input.value) || 0
      const variantId = input.dataset.variantId

      if (qty > 0 && variantId) {
        const productCard = input.closest('[data-product-index]')
        const title = productCard?.querySelector('.hkt--multi-atc__form-product-title--price h2')?.textContent.trim() || ''
        const imageSrc = productCard?.querySelector('img')?.src || ''
        const items = [{ id: variantId, quantity: qty, title, imageSrc }]

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items })
        })
          .then(() => {
            const cartCountBubble = document.querySelector('.cart-count-bubble')
            if (cartCountBubble) cartCountBubble.textContent = parseInt(cartCountBubble.textContent || 0) + qty
            showSuccessPopupFromCart(items)
            input.value = 0
            updateTotal()
          })
          .catch(err => console.error("Add to cart failed:", err))
      }
    })
  })

}

function showSuccessPopupFromCart(addedItems, instant = false) {
  const popup = document.getElementById("hkt--success-popup")
  if (!popup || !addedItems) return

  let contentHtml = `
    <button id="hkt--success-popup-close" style="position:absolute;top:5px;right:8px;background:transparent;border:none;color:black;font-size:18px;cursor:pointer;">&times;</button>
    <strong>Added to Cart:</strong><br>
    <ul style="list-style:none;padding-left:0;margin:0;margin-top:8px;">
  `

  addedItems.forEach(item => {
    const inputEl = document.querySelector(`.hkt--multi-atc-qty-input[data-variant-id="${item.id}"]`)
    const finalQty = inputEl ? inputEl.value : item.quantity
    contentHtml += `
      <li style="display:flex;align-items:center;margin-bottom:8px;">
        <img src="${item.imageSrc}" alt="${item.title}" style="width:40px;height:40px;object-fit:cover;margin-right:10px;border-radius:4px;"/>
        <span>${item.title} × <span style="color:green;font-weight:bold;">${finalQty}</span></span>
      </li>
    `
  })

  contentHtml += `
    </ul>
    <div style="text-align:right;margin-top:15px;">
      <a href="/checkout" class="hk-popup-checkout">Proceed to Checkout</a>
    </div>
  `

  popup.innerHTML = contentHtml
  popup.style.display = "block"
  popup.style.opacity = "1"
  popup.style.position = "fixed"
  popup.style.top = "100px"
  popup.style.right = "20px"
  popup.style.background = "#fff"
  popup.style.color = "#000"
  popup.style.padding = "15px 20px"
  popup.style.borderRadius = "5px"
  popup.style.zIndex = "9999"
  popup.style.maxWidth = "320px"
  popup.style.boxShadow = "0 2px 8px rgba(0,0,0,0.2)"

  const closeBtn = document.getElementById("hkt--success-popup-close")
  if (closeBtn) closeBtn.addEventListener("click", () => {
    popup.style.display = "none"
    popup.innerHTML = ""
    popup.style.opacity = "0"
    popup.style.transition = ""
  })

  clearTimeout(popup._hideTimeout)
  popup._hideTimeout = setTimeout(() => {
    popup.style.transition = "opacity 0.5s ease"
    popup.style.opacity = "0"
    setTimeout(() => {
      popup.style.display = "none"
      popup.style.transition = ""
      popup.innerHTML = ""
    }, 500)
  }, instant ? 1000 : 1500)
}

window.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.querySelectorAll("[id^='multi-atc-section-']").forEach((el, index) => {
      const id = el.id.replace('multi-atc-section-', '') + "-" + index
      el.setAttribute('data-section-id', id)
      initMultiAtcSection(id)
    })
  }, 200)
})

// Variant Options Script

// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.custom-variant-dropdown').forEach(dropdown => {
//     const selected = dropdown.querySelector('.selected-variant')
//     const list = dropdown.querySelector('.variant-options')
//     const hiddenInput = dropdown.querySelector('input[name="id"]')

//     selected.addEventListener('click', () => {
//       list.style.display = list.style.display === 'block' ? 'none' : 'block'
//     })

//     list.querySelectorAll('li').forEach(item => {
//       item.addEventListener('click', () => {
//         selected.querySelector('span').textContent = item.dataset.title
//         selected.querySelector('img').src = item.dataset.img
// let selectedVariantId = item.dataset.id
// hiddenInput.value = selectedVariantId

// dropdown.closest('form').querySelectorAll('input[name="id"]').forEach(input => {
//   input.value = selectedVariantId
// })

// dropdown.closest('form').querySelectorAll('.hkt--multi-atc-qty-input').forEach(input => {
//   input.dataset.variantId = selectedVariantId
// })

//         list.style.display = 'none'
//       })
//     })

//     document.addEventListener('click', e => {
//       if (!dropdown.contains(e.target)) {
//         list.style.display = 'none'
//       }
//     })
//   })
// })
// $(document).on('click', '.variant-options li', function () {
//   let variantId = $(this).data('id')
//   let title = $(this).data('title')
//   let img = $(this).data('img')
//   let stock = $(this).data('stock') || 0
//   let form = $(this).closest('form')

//   if (stock == 0) {
//     alert("This variant is out of stock!")
//     return false
//   }

//   // ✅ Update hidden ID
//   form.find('input[name="id"]').val(variantId)

//   // ✅ Update quantity input
//   form.find('.hkt--multi-atc-qty-input').each(function () {
//     $(this)
//       .val(0) // reset quantity to 0
//       .attr('data-variant-id', variantId)
//       .attr('data-max-stock', stock)
//   })

//   // ✅ Update price
//   form.find(`[id^="product-dynamic-price-"]`).attr('data-variant-id', variantId)
//   fetch(`/variants/${variantId}.js`)
//     .then(res => res.json())
//     .then(data => {
//       let price = (data.price / 100).toFixed(2)
//       form.find(`[id^="product-dynamic-price-"]`).text(price)
//     })

//   // ✅ Update image
//   form.find('.hkt--multi-atc__form-product-img img')
//     .attr('src', img)
//     .attr('alt', title)
// })
$(document).on('click', '.variant-pill', function () {
  let $this = $(this)
  let variantId = $this.data('id')
  let stock = +$this.data('stock')
  let form = $this.closest('form')

  if (stock <= 0) {
    alert('Soldout')
    return
  }

  // Update selected class
  $this.closest('.variant-pills').find('.variant-pill').removeClass('selected')
  $this.addClass('selected')

  // Update hidden input
  form.find('input[name="id"]').val(variantId)

  // Reset qty + update stock attributes
  form.find('.hkt--multi-atc-qty-input').each(function () {
    $(this)
      .val(0)
      .attr('data-variant-id', variantId)
      .attr('data-max-stock', stock)
  })

  // Update price
  form.find(`[id^="product-dynamic-price-"]`).attr('data-variant-id', variantId)
  fetch(`/variants/${variantId}.js`)
    .then(res => res.json())
    .then(data => {
      let price = (data.price / 100).toFixed(2)
      form.find(`[id^="product-dynamic-price-"]`).text(price)

      // Update image
      if (data.featured_image && data.featured_image.src) {
        form.find('.hkt--multi-atc__form-product-img img')
          .attr('src', data.featured_image.src)
          .attr('alt', data.title)
      }
    })
})



